const getNames = directory => {
    const caName = directory[0];
    const subareaName = directory[1]==='subareas' && directory[2];
    const designationAreaName = directory[1]==='designations' && directory[2];
    return {caName, subareaName, designationAreaName};
}

export default getNames;